module.exports = __webpack_public_path__ + "img/35_40.5ce73219.png";